export function ExpertiseDetailSkeleton() {
  return (
    <div className="flex w-full animate-pulse flex-col gap-6" aria-hidden="true">
      {/* Back button */}
      <div className="h-4 w-20 rounded bg-gray-200" />

      {/* Header */}
      <div className="flex flex-col gap-2 border-b border-gray-200 pb-4">
        <div className="flex items-center gap-3">
          <div className="h-7 w-48 rounded bg-gray-200" />
          <div className="h-5 w-20 rounded-full bg-gray-200" />
        </div>
        <div className="h-4 w-40 rounded bg-gray-200" />
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {/* Left column */}
        <div className="space-y-6">
          {/* Doctor */}
          <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
            <div className="mb-3 h-3 w-16 rounded bg-gray-200" />
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-full bg-gray-200" />
              <div className="space-y-2">
                <div className="h-4 w-32 rounded bg-gray-200" />
                <div className="h-3 w-24 rounded bg-gray-200" />
              </div>
            </div>
          </div>

          {/* Files */}
          <div>
            <div className="mb-2 h-3 w-20 rounded bg-gray-200" />
            <div className="space-y-3 rounded-xl border border-gray-200 bg-white p-4">
              <div className="h-4 w-full rounded bg-gray-200" />
              <div className="h-4 w-3/4 rounded bg-gray-200" />
              <div className="h-20 w-full rounded-lg bg-gray-100" />
            </div>
          </div>

          {/* Form submissions */}
          <div>
            <div className="mb-2 h-3 w-28 rounded bg-gray-200" />
            <div className="h-24 rounded-xl border border-gray-200 bg-white p-4" />
          </div>
        </div>

        {/* Right column - chat */}
        <div className="rounded-xl border border-gray-200 bg-white p-4">
          <div className="mb-4 h-3 w-24 rounded bg-gray-200" />
          <div className="space-y-4">
            <div className="h-12 w-2/3 rounded-2xl bg-gray-100" />
            <div className="ml-auto h-12 w-1/2 rounded-2xl bg-gray-200" />
            <div className="h-12 w-3/5 rounded-2xl bg-gray-100" />
          </div>
        </div>
      </div>
    </div>
  )
}
